import gql from 'graphql-tag';

import mainDisplayObjectFragment from './mainDisplayObjectFragment';

export const relatedMainDisplayObjectFragment = gql`
  fragment relatedMainDisplayObjectFragment on RelatedMainDisplayObject {
    dokkioClass
    mainDisplayObject {
      ...mainDisplayObjectFragment
    }
    confidence
  }
  ${mainDisplayObjectFragment}
`;
export default relatedMainDisplayObjectFragment;
